import React from 'react';
import { Typography } from '@material-ui/core';

interface Props {
    content: string;
}

const ShowNoteContent: React.FC<Props> = ({ content }) => {
    return (
        <Typography variant='body2' style={{ whiteSpace: 'pre-wrap' }}>
            {content}
        </Typography>
    );
};

export default ShowNoteContent;
